import * as React from 'react';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer } from './hooks/useLocalizer';
import { AIHeader } from './AIHeader';
import { AITryAgainButton } from './AITryAgainButton';
import { AIUploadDifferentFilesButton } from './AIUploadDifferentFilesButton';
import { UploadedFile } from './types';
import { DataCollectionAiAgentOperationType } from '../../../store/Models/Surveys/SurveyDataModel';

const failureIconSrc = "/images/supplier-ai-agent/failure-icon.svg";
const failureMessageIconSrc = "/images/supplier-ai-agent/failure-message-icon.svg";

interface AIFailureStateProps {
    requestId?: string;
    operationId?: string;
    uploadedFiles: UploadedFile[];
    operationType: DataCollectionAiAgentOperationType;
    onClearError?: () => void;
    onError?: (message: string) => void;
    localizer?: IStringLocalizer;
    errorMessage?: string;
}

export const AIFailureState: React.FC<AIFailureStateProps> = ({
    requestId,
    operationId,
    uploadedFiles,
    operationType,
    onClearError,
    onError,
    localizer,
    errorMessage
}) => {
    const localize = useLocalizer(localizer);

    return (
        <>
            <div>
                <AIHeader localizer={localizer} />
            </div>
            <div className="ai-failure-container">
                {/* Failure Icon with Red Background */}
                <div className="ai-failure-icon-circle">
                    <img src={failureIconSrc} width="32" height="32" aria-hidden="true" alt="" />
                </div>

                {/* Title */}
                <h4 className="ai-failure-subheading">{localize("Processing Failed")}</h4>

                {/* Error Message Box */}
                <div className="ai-failure-message-box">
                    <div className="ai-failure-message-icon">
                        <img src={failureMessageIconSrc} width="20" height="20" aria-hidden="true" alt="" />
                    </div>
                    <div className="ai-failure-message-content">
                        <p className="ai-failure-message-text">
                            {errorMessage || localize("We encountered an issue while processing your documents. This could be due to unsupported content, file corruption, or a temporary service issue.")}
                        </p>
                        <p className="ai-failure-files-preserved">
                            {localize("Your uploaded files have been preserved.")}
                        </p>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="ai-failure-button-container">
                    <AITryAgainButton 
                        requestId={requestId}
                        operationId={operationId}
                        uploadedFiles={uploadedFiles}
                        operationType={operationType}
                        onClearError={onClearError} 
                        onError={onError} 
                        localizer={localizer} 
                    />
                    <AIUploadDifferentFilesButton 
                        onError={onError} 
                        localizer={localizer} 
                    />
                </div>

            </div>
        </>
    );
};

export default AIFailureState;
